<template>
  <div class="d-flex flex-wrap justify-content-between align-items-center">
    <div class="col-md-2 col-12">
      <b-badge variant="warning" class="px-2 text-wrap py-1">
        {{ text }}
      </b-badge>
    </div>
    <div class="col-12 col-md-9">
      <div class="d-flex flex-wrap col-12">
        <b-form-group
          class="col-md-6 col-12"
          label="وضعیت"
          label-for="add-topic-sessions-status"
        >
          <validation-provider
            #default="{ errors }"
            name="sessions-status"
            vid="sessions-status"
            rules="required"
          >
            <select-box
              v-model="status"
              select="value"
              label="name"
              :lists="otherSessions.length ? statuses2 : statuses1"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          v-if="otherSessions.length && status == 1"
          class="col-md-6 col-12"
          label="پیش نیاز"
          label-for="add-topic-sessions"
        >
          <validation-provider
            #default="{ errors }"
            name="sessions"
            vid="sessions"
            rules="required"
          >
            <select-box
              :loader="loader"
              v-model="prerequisites"
              multiple
              select="id"
              label="text"
              :lists="otherSessions"
              :disabled="!otherSessions.length"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          class="col-md-6 col-12"
          label="تاریخ شروع جلسه"
          label-for="add-course-available-at"
        >
          <validation-provider
            #default="{ errors }"
            name="started-at"
            vid="started-at"
          >
            <date-picker
              v-model="started_at"
              autocomplete="on"
              id="add-course-started-at"
              type="datetime"
              clearable
              name="add-course-started-at"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          class="col-md-6 col-12"
          label="تاریخ پایان جلسه"
          label-for="add-course-finished-at"
        >
          <validation-provider
            #default="{ errors }"
            name="finished-at"
            vid="finished-at"
          >
            <date-picker
              v-model="finished_at"
              autocomplete="on"
              id="add-course-finished-at"
              type="datetime"
              clearable
              name="add-course-finished-at"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </div>
      <div class="col-12">
        <div>
          <b-form-group
            label="تمرین ها"
            label-for="add-course-exercises"
            class="w-100"
          >
            <validation-provider
              #default="{ errors }"
              name="exercises"
              vid="exercises"
              class="d-flex justify-content-start align-items-center"
            >
              <select-box
                v-model="exercises"
                multiple
                label="text"
                class="w-100"
                url="exercise"
                searchable
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </div>
        <div>
          <draggable
            v-if="exercises && exercises.length"
            v-model="exercises"
            class="list-group list-group-flush cursor-move"
            tag="ul"
          >
            <b-list-group-item
              v-for="(exercise, exerciseIndex) in exercises"
              :key="'exercise-' + exerciseIndex"
              tag="li"
              class="px-0"
            >
              <exercise-row
                :exercise="exercise"
                v-model="newExercises[exerciseIndex]"
              />
            </b-list-group-item>
          </draggable>
        </div>
      </div>
    </div>
    <div class="col-md-1 d-flex justify-content-end col-12">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="warning"
        size="sm"
        class="btn-icon rounded-circle"
        @click="$emit('removeSession', session.id)"
      >
        <feather-icon icon="TrashIcon" />
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormInput,
  BBadge,
  BFormCheckbox,
  BListGroupItem,
} from "bootstrap-vue";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import ExerciseRow from "./exerciseRow.vue";
export default {
  components: {
    BButton,
    SelectBox,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormCheckbox,
    BBadge,
    draggable,
    BListGroupItem,
    ExerciseRow,
  },
  data() {
    return {
      required,
      statuses1: [
        { name: "قفل", value: "0" },
        { name: "آزاد", value: "2" },
        { name: "پیش نمایش", value: "3" },
      ],
      statuses2: [
        { name: "قفل", value: "0" },
        { name: "وابسته", value: "1" },
        { name: "آزاد", value: "2" },
        { name: "پیش نمایش", value: "3" },
      ],
      otherSessions: [],
      id: null,
      text: "",
      status: "",
      exercises: [],
      newExercises: [],
      started_at: "",
      prerequisites: [],
      finished_at: "",
      loader: false,
    };
  },
  directives: {
    Ripple,
  },

  props: {
    topicSessions: {
      type: Array,
      default: () => [],
    },
    session: {
      type: Object,
      default: () => {},
    },
    sessionIndex: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.otherSessions = [...this.topicSessions];
    this.otherSessions.splice(
      this.topicSessions.findIndex((session) => session.id == this.id),
      this.topicSessions.length
    );
    Object.keys(this.session).map((key) => {
      this[key] = this.session[key];
    });
  },
  watch: {
    exercises(val) {
      if (val.length < this.newExercises.length) {
        if (val.length) {
          this.newExercises = this.newExercises.filter(
            (newExercise) =>
              val.findIndex((exercise) => {
                return exercise.id == newExercise.id;
              }) > -1
          );
        } else {
          this.newExercises = [];
        }
      }
    },
    async topicSessions(newVal) {
      this.otherSessions = await [...newVal];
      await this.otherSessions.splice(
        newVal.findIndex((session) => session.id == this.id),
        newVal.length
      );
    },
    session(val) {
      if (this.sessionIndex == 0 && val.status == "1") {
        val.prerequisites = [];
        val.status = "";
      }
      if (this.sessionIndex != 0 && val.prerequisites && val.prerequisites.length) {
        val.prerequisites = val.prerequisites.filter((prerequisite) => {
          return (
            this.otherSessions.findIndex(
              (session) => session.id == prerequisite
            ) > -1
          );
        });
      }

      Object.keys(val).map((key) => {
        this[key] = val[key];
      });
    },
    newSession(val) {
      Object.keys(val).map((key) => {
        this.session[key] = this[key];
      });

      this.$emit("input", val);
    },
  },
  computed: {
    newSession() {
      return {
        id: this.id,
        text: this.text,
        status: this.status,
        exercises: this.newExercises,
        started_at: this.started_at,
        prerequisites: this.prerequisites,
        finished_at: this.finished_at,
      };
    },
  },
};
</script>

<style></style>
